<template>
    <resturants-filter />
</template>

<script>
import ResturantsFilter from "./ResturantsFilterMobile";
import shared from "../../../sharedscripts/master/Resturant/Resturants.js";
export default {
  name: "Resturants",
  components: {
    ResturantsFilter
  },
  data() {
    return {
      ...shared.data()
    };
  },
  methods: {
    ...shared.methods
  },
  created() {
    if (
      !this.isWC() &&
      !this.isBranded() &&
      process.env.NODE_ENV === "production"
    ) {
      window.location = "https://www.abacus.co/";
    }
  }
};
</script>
